import { faArrowLeft } from "@insidebeehive/fortawesome/pro-solid-svg-icons/faArrowLeft";
import { useTranslation } from "react-i18next";

import { Button } from "../ui/button";

import type { ButtonProps } from "../ui/button";

interface Props extends ButtonProps {
  buttonType?: "back";
}

const ActionButton = ({ buttonType, ...props }: Props) => {
  const { t } = useTranslation("common");

  switch (buttonType) {
    case "back":
      return (
        <Button icon={faArrowLeft} variant="outline" type="button" className="md:gap-1" {...props}>
          <span className="hidden md:block">{t("actions.back")}</span>
        </Button>
      );

    default:
      return <Button {...props} />;
  }
};

export default ActionButton;
